/** IDs de findings que el usuario ha descartado en este proyecto. */
export type InspectorDismissedId = string

export function normalizeInspectorDismissed(value: unknown): InspectorDismissedId[] {
  if (!Array.isArray(value)) return []
  const unique = new Set<string>()
  for (const id of value) {
    if (typeof id === 'string' && id.length > 0) unique.add(id)
  }
  return Array.from(unique)
}
